import { render, staticRenderFns } from "./enrollment-details.vue?vue&type=template&id=4cd805e6&scoped=true&"
import script from "./enrollment-details.ts?vue&type=script&lang=ts&"
export * from "./enrollment-details.ts?vue&type=script&lang=ts&"
import style0 from "./enrollment-details.scss?vue&type=style&index=0&id=4cd805e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd805e6",
  null
  
)

export default component.exports